// extracted by mini-css-extract-plugin
module.exports = {"container":"SyncIndicator_container__oZFCO","pending":"SyncIndicator_pending__2Nf_X","failed":"SyncIndicator_failed__2E9M5","succeed":"SyncIndicator_succeed__1cUdr"};